import { useRouter } from 'next/router';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';
import isEmpty from 'lodash/isEmpty';
import { FieldError } from 'react-hook-form';

import { emailRegex, lettersRegex } from '../../utils/regex';
import { MetaPages } from '../../enums/pages';
import FormFieldWrapper from '../../components/organisms/form-field-wrapper/form-field-wrapper';
import RequiredTooltip from '../../components/atoms/required-tooltip/required-tooltip';
import MarginSpacing from '../../components/atoms/margin-spacing/margin-spacing';
import FormErrorMessage from '../../components/atoms/form-error-message/form-error-message';
import { errorMessage } from '../../constants/forms';
import ReceiveEmailsOption from '../../components/atoms/receive-emails-option/receive-emails-option';
import FormSubmitButton from '../../components/atoms/form-submit-button/form-submit-button';
import { useRequestQuotationForm } from '../../hooks/useRequestQuotationForm';
import FormTitle from '../../components/atoms/form-title/form-title';
import SectionDescription from '../../components/atoms/section-description/section-description';
import TabTitle from '../../components/atoms/tab-title/tab-title';
import { Bitrix24Form } from '../../components/atoms/bitrix/bitrix';

export const Container = styled.div.attrs({
  className:
    'grid grid-cols-1 md:grid-cols-2 gap-x-8 w-full max-w-defaultMax mb-5 mx-auto'
})`
  input {
    font-family: MuseoSans-100;
    font-size: 14px;
    border: 1px solid #e3e4e3;
    width: 100%;
    margin: 5px 0px;
    padding: 8px 12px;
    filter: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  }

  input:focus{
    outline: none;
  }

  input::placeholder {
    font-family: MuseoSans-100;
    font-weight: 200;
    font-color: '
      #e3e4e3;
  }
`;

export function Index() {
  // const {
  //   Controller,
  //   control,
  //   errors,
  //   recaptchaRef,
  //   handleSubmit,
  //   onSubmit,
  //   setValue
  // } = useRequestQuotationForm();

  // const router = useRouter();
  // const { query } = router;

  // if (!isEmpty(query?.email)) setValue('email', query?.email as string);

  return (
    <>
      <TabTitle page={MetaPages.ABOUT_QUOTATION} />
      <div className="px-5 flex flex-col justify-center items-center my-10 md:mt-20 md:mb-10">
        <FormTitle title="REQUEST FOR QUOTATION" />
        <Bitrix24Form
          src="https://cdn.bitrix24.com/b26420757/crm/form/loader_216.js"
          data="inline/216/m9xxso"
        />
        {/* <FormTitle title="REQUEST FOR QUOTATION" />
        <SectionDescription
          isCentered
          description="Please fill out the form below for our team to be able to get back to you as soon as possible"
        />
        <MarginSpacing margin="mb-2" />
        <div className="min-w-full w-full">
          <div className="m-auto max-w-defaultMax">
            <RequiredTooltip />
          </div>
          <form action="#" method="POST" onSubmit={handleSubmit(onSubmit)}>
            <Container>
              <FormFieldWrapper
                control={control}
                error={errors.lastName as FieldError}
                fieldName="lastName"
                placeHolder="Last Name"
                rules={{
                  pattern: lettersRegex,
                  required: true
                }}
              />
              <FormFieldWrapper
                control={control}
                error={errors.firstName as FieldError}
                fieldName="firstName"
                placeHolder="First Name"
                rules={{ pattern: lettersRegex, required: true }}
              />
              <FormFieldWrapper
                control={control}
                error={errors.contactNumber as FieldError}
                fieldName="contactNumber"
                placeHolder="Contact Number"
                rules={{ required: true }}
                type="number"
              />
              <FormFieldWrapper
                shouldAcceptLettersAndNumbers
                control={control}
                customErrorMessage="Invalid email format"
                error={errors.email as FieldError}
                fieldName="email"
                placeHolder="E-mail"
                rules={{
                  required: true,
                  validate: (value) =>
                    value.match(emailRegex) || 'Invalid email format'
                }}
              />
              <FormFieldWrapper
                shouldAcceptLettersAndNumbers
                control={control}
                error={errors.address as FieldError}
                fieldName="address"
                placeHolder="Address"
              />
              <FormFieldWrapper
                shouldAcceptLettersAndNumbers
                control={control}
                error={errors.city as FieldError}
                fieldName="city"
                placeHolder="City"
                rules={{ pattern: lettersRegex, required: true }}
              />
            </Container>
            <div className="w-full max-w-defaultMax font-MuseoSans100 text-subtitle flex flex-col m-auto">
              <Controller
                control={control}
                name="productsForRequest"
                rules={{ required: true }}
                render={({ field }) => (
                  <textarea
                    className="w-full border-2 px-3 py-2 focus:border-formGray outline-transparent"
                    rows={5}
                    placeholder="*Do you have particular products you're interested in?"
                    {...field}
                  />
                )}
              />
              <FormErrorMessage
                errors={errors.productsForRequest as FieldError}
                message={errorMessage}
              />
              <Controller
                control={control}
                name="isSubscribed"
                rules={{ required: true }}
                render={({ field }) => <ReceiveEmailsOption {...field} />}
              />
              <FormErrorMessage
                errors={errors.isSubscribed as FieldError}
                message="Please select an option"
              />
            </div>
            <div className="w-full max-w-defaultMax m-auto">
              <ReCAPTCHA
                className="mt-3"
                ref={recaptchaRef}
                sitekey={process.env.NEXT_PUBLIC_SZWF_SITE_KEY as string}
              />
              <div className="mt-3 p-2 bg-black inline-block self-start">
                <FormSubmitButton />
              </div>
            </div>
          </form>
        </div> */}
      </div>
    </>
  );
}

export default Index;
